import React, { Component } from 'react';
import $ from "jquery";
import {  Link } from 'react-router-dom';

class Chamber extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card borderNone">
                          <div className="card-body">
                            <h5 className="card-title">Die Kanzlei</h5>
                            <h6 className="card-subtitle mb-2 text-muted"></h6>
                            <p className="card-text">
                                Die Steuerberatungskanzlei&nbsp; R&uuml;diger Heckmann&nbsp; ist aus der fr&uuml;heren Wirtschaftspr&uuml;fer- und Steuerberatungskanzlei Rudolf Diepenbeck und R&uuml;diger Heckmann – Wirtschaftpr&uuml;fer und Steuerberater – in D&uuml;sseldorf,&nbsp; im Jahre 2003 hervorgegangen.
                                <br />
                                Der Inhaber der Kanzlei, R&uuml;diger Heckmann hat nach Abschluss seiner Berufsausbildung an der Fachhochschule f&uuml;r Finanzen in Nordkirchen (NRW) im Jahre 1971 und dem Abschluss des Studiums der Wirtschaftswissenschaften an der Universit&auml;t Duisburg im Jahre 1977 in verschiedenen Steuerberatungs- und Wirtschaftpr&uuml;fungskanzleien erste Berufserfahrungen gesammelt.
                                <br />
                                In den Jahren 1980 bis 1987 bestand die T&auml;tigkeit, die im Angestelltenverh&auml;ltnis bei einer namhaften Wirtschaftspr&uuml;fungs- und Steuerberatungsgesellschaft ausge&uuml;bt wurde,&nbsp; im wesentlichen in der Erstellung von Jahresabschl&uuml;ssen und Steuererkl&auml;rungen&nbsp; und der steuerlichen und betriebswirtschaftlichen Beratung von mittelst&auml;ndischen Unternehmen verschiedenster Branchen.
                                <br />
                                Seit dem 01.01.1988 wurde im Rahmen eines Gesellschaftsverh&auml;ltnisses (Gesellschaft b&uuml;rgerlichen Rechts – GbR)&nbsp; mit Herrn Dipl.-&Ouml;k.&nbsp; Rudolf Diepenbeck, Wirtschaftspr&uuml;fer und Steuerberater,&nbsp; eine Gemeinschaftskanzlei betrieben, die im Wege der Realteilung im Jahre 2003 aufgegeben worden ist.
                                <br />
                                Die heute bestehende Kanzlei R&uuml;diger Heckmann ist Mitglied der:
                                <br />
                                <br />
                                <span className="lead">
                                    Wirtschaftspr&uuml;ferkammer
                                    <br />
                                    Steuerberaterkammer NRW
                                    <br />
                                    Steuerberaterverbandes NRW
                                </span> 
                            </p>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Chamber;


// WEBPACK FOOTER //
// ./src/Chamber.js